// extracted by mini-css-extract-plugin
module.exports = {"imgHeading":"styles_imgHeading__1hElx"};